import { Injectable } from "@angular/core";
import { Http, RequestOptions, Response } from "@angular/http";
import "rxjs/add/observable/of";
import "rxjs/add/observable/throw";
import "rxjs/add/operator/catch";
import "rxjs/add/operator/map";
import { Observable } from "rxjs/Observable";
import { TestOrder } from "../../models";
import { UtilService } from "../util";

@Injectable()
export class TestOrderService {
  constructor(private http: Http, private utilService: UtilService) {}

  getICDCodes(searchField?: string): Observable<Array<ICDCode>> {
    let url = "/codes";
    if (searchField) {
      url += `?q=${searchField}`;
    }

    return this.http
      .get(url)
      .map((res: Response) => JSON.parse(res["_body"]))
      .catch(this.utilService.handleError);
  }

  getCategories(): Observable<Array<TestCategory>> {
    return this.http
      .get("/categories")
      .map((res: Response) => JSON.parse(res["_body"]))
      .catch(this.utilService.handleError);
  }

  getAllTestOrders(
    searchCriteria: SearchCriteria
  ): Observable<Array<CreatedTestOrder>> {
    let queryParams = this.utilService.setQueryParams({
      q: searchCriteria.SearchTerm,
      sort: searchCriteria.Sort,
      order: searchCriteria.Order,
      page: searchCriteria.PageNumber
    });
    let options = new RequestOptions({ params: queryParams });
    return this.http
      .get("/encounters", options)
      .map((res: Response) => res.json())
      .catch(this.utilService.handleError);
  }

  getAllFavorites(searchField: string): Observable<any> {
    let url = "/panels/favorites";
    let queryParams = this.utilService.setQueryParams({
      q: searchField
    });
    let options = new RequestOptions({ params: queryParams });
    return this.http
      .get(url, options)
      .map((res: Response) => JSON.parse(res["_body"]))
      .catch(this.utilService.handleError);
  }

  getAllTests(searchField: string): Observable<any> {
    let url = "/panels";
    let queryParams = this.utilService.setQueryParams({
      q: searchField
    });
    let options = new RequestOptions({ params: queryParams });
    return this.http
      .get(url, options)
      .map((res: Response) => JSON.parse(res["_body"]))
      .catch(this.utilService.handleError);
  }

  getTestsByCategoryId(
    categoryId: string,
    searchField: string
  ): Observable<any> {
    let url = `/categories/${categoryId}/panels`;
    let queryParams = this.utilService.setQueryParams({
      q: searchField
    });
    let options = new RequestOptions({ params: queryParams });

    return this.http
      .get(url, options)
      .map((res: Response) => JSON.parse(res["_body"]))
      .catch(this.utilService.handleError);
  }

  createTestOrder(testOrder: TestOrder): Observable<Response> {
    let testOrderPayload = {
      PatientId: testOrder.PatientId,
      ICDCodeIds: testOrder.ICDCodeIds,
      PanelIds: testOrder.PanelIds,
      PhysicianId: testOrder.PhysicianId,
      ReleasedOn: testOrder.ReleaseOn,
      LocationId: testOrder.LocationId
    };
    return this.http
      .post("/encounters", testOrderPayload)
      .catch(this.utilService.handleError);
  }

  setStatus(status: string, orderId: number, patientId: number) {
    let statusToEndpointMapping = {
      pending: "abort"
    };
    let url =
      `/patient/${patientId}/order/${orderId}/` +
      statusToEndpointMapping[status];
    return this.http.post(url, {}).catch(this.utilService.handleError);
  }

  recordTestOrderReportView(reportId: number) {
    return this.http
      .get(`/encounters/${reportId}/report`)
      .catch(this.utilService.handleError);
  }

  favoritePanel(panelId: number): Observable<Response> {
    return this.http
      .put(`/panels/${panelId}/favorites`, {})
      .catch(this.utilService.handleError);
  }

  unfavoritePanel(panelId: number): Observable<Response> {
    return this.http
      .delete(`/panels/${panelId}/favorites`)
      .catch(this.utilService.handleError);
  }
}



// WEBPACK FOOTER //
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/app/shared/services/test-order/test-order.service.ts